import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsButtonModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyRouterModule } from '../../route.module';
import { VoiceService } from '../core';

import { VoiceProfileComponent } from './voice-profile.component';
import { VoiceProfileRoutes } from './voice-profile.route';

@NgModule({
    declarations: [VoiceProfileComponent],
    exports: [VoiceProfileComponent],
    imports: [
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(VoiceProfileRoutes),
        CommonModule,
    ],
    providers: [VoiceService],
})
export class CmpsLocalCallVoiceProfileModule {}
